// eslint-disable-next-line no-restricted-imports
import { Cell, flexRender, Row } from "@tanstack/react-table";

type TableCellContentProps<T> = {
    cell: Cell<T, unknown>;
} & Record<string, unknown>;

/**
 * Renders one cell through its column's `cell` definition. Extra props are added to the cell context the
 * definition receives.
 */
export const TableCellContent = <T,>({ cell, ...extraContext }: TableCellContentProps<T>) =>
    flexRender(cell.column.columnDef.cell, { ...cell.getContext(), ...extraContext });

/**
 * Renders every visible cell of a TanStack row. Goes inside the row element (`HoverRow`, `MinimalTableRow`, …).
 */
export const TableRowCells = <T,>({ row }: { row: Row<T> }) =>
    row.getVisibleCells().map((cell) => <TableCellContent key={cell.id} cell={cell} />);
